import {Box, Flex} from "@mantine/core";
import {FC, memo} from "react";
import {SimpleColumnMapping} from "@/PageComponents/SimpleTable/SimpleTable";
import styles from "@/PageComponents/SectionTable/SectionTable.module.css";
import {TableAction, TableActionStates} from "@/PageComponents/Table/table-model";
import ScTableActionCell from "@/PageComponents/Table/Table/ScTableActionCell";
import SimpleTableCell from "@/PageComponents/SimpleTable/SimpleTableCell";
import {IconNewSection} from "@tabler/icons-react";

export interface SectionTableSectionItemProps {
    item: any
    isSection: boolean
    groupIndex: number
    mapping: SimpleColumnMapping[]
    canEdit?: boolean
    controls?: TableAction[]
    stylingProps?: {
        compact?: boolean
        rows?: boolean
        darkerText?: boolean
    }
    tableActionStates?: TableActionStates
    showControlsOnHover?: boolean
    // this item's entry from tableItemInputMetadataByKeyName, keyed by value key name
    inputMetadata?: { [itemValueKeyName: string]: { disabled: boolean; loading: boolean; error?: string | null } }
    allowSections?: boolean
    lineClamp?: number
    onInputChange?: (name: string, item: any, value: number | '') => void
    onItemClicked?: (item: any, column: string) => void
    // calls the table's onAction with this row's group and group index
    onRowAction: (actionName: string, item: any) => void
    onCreateNewSection?: (item: any) => void
}

const SectionTableGroupRowWrapper: FC<SectionTableSectionItemProps> = (props: any) => {

    return (
        <>

            {
                props.mapping.map(
                    ({
                         key: itemKey, valueFunction, type, linkAction,
                         min, linkHrefFunction, colorKey, placeholderFunction, ...others
                     }: any, j: any) => {

                        const key = others.keyFunction ? others.keyFunction(props.item) : itemKey;
                        const color = others.colorFunction ? others.colorFunction(props.item) : colorKey && props.item[colorKey];

                        const shown = others.showFunction ? others.showFunction(props.item) : true;

                        const typeToCheck = others.typeFunction ? others.typeFunction(props.item) : type;

                        return (
                            <td key={'simp' + (props.item?.ID || props.item?.id) + 'row' + j + 'col'}
                                style={{maxWidth: '40vw'}}
                            >
                                <Box
                                    w={typeToCheck === "textArea" || typeToCheck === "textInput" ? "100%" : "max-content"}
                                    maw={'100%'}
                                    miw={others.stylingProps?.miw}
                                    style={{cursor: props.onItemClicked && type === 'status' ? 'pointer' : 'default'}}
                                    onClick={() => props.onItemClicked && props.onItemClicked(props.item, key)}
                                    ml={others.alignRight || others.currencyValue ? 'auto' : 0}
                                    mr={others.alignRight || others.currencyValue ? 10 : 0}
                                >
                                    <Flex>
                                        {props.isSection && j === 0 ? <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</> : j === 0 ? <>&nbsp;&nbsp;</> : '' }
                                        <SimpleTableCell
                                            key={props.item.ID + key}
                                            data={valueFunction ? valueFunction(props.item) : props.item[key]}
                                            type={others.typeFunction ? others.typeFunction(props.item) : type}
                                            onActionLinkClick={!linkAction ? undefined : (() => {
                                                props.onRowAction(linkAction, props.item)
                                            })}
                                            linkHref={linkHrefFunction ? linkHrefFunction(props.item) : undefined}
                                            canEdit={props.canEdit ?? true}
                                            stylingProps={props.stylingProps}
                                            onValueChange={(newVal: any) => props.onInputChange && props.onInputChange(key, props.item, newVal)}
                                            min={typeof min === 'function' ? min(props.item) : min}
                                            color={color}
                                            inputProps={props.inputMetadata?.[key]}
                                            placeholder={!placeholderFunction ? undefined : placeholderFunction(props.item)}
                                            shown={shown}
                                            lineClamp={props.lineClamp}
                                            {...others}
                                            required={others.required ?? (others.requiredFunction && others.requiredFunction(props.item))}
                                            item={props.item}
                                        />
                                    </Flex>

                                </Box>
                            </td>
                        )
                    }
                )
            }

            <td className={styles.actions + ' ' + (props.showControlsOnHover === false ? styles.show : '')}>
                {
                    props.controls && props.controls.length !== 0 &&
                    <ScTableActionCell
                        tooltipShowDelay={500}
                        mih={0}
                        actions={[
                            ...(!props.isSection && props.allowSections !== false && [{
                                name: 'createSection',
                                label: 'Create Section',
                                icon: <IconNewSection/>
                            }] || []),
                            ...props.controls,
                        ]}
                        data={props.item}
                        onAction={(actionName: any) => {
                            actionName === 'createSection' ? props.onCreateNewSection && props.onCreateNewSection(props.item) : props.onRowAction(actionName, props.item)
                        }}
                        actionIconPropsOverride={{
                            // variant: 'transparent',
                            // color: 'gray',
                            size: 'xs',
                        }}
                        states={props.tableActionStates}
                    />
                }
            </td>
        </>
    )
}

export default memo(SectionTableGroupRowWrapper)
